import clsx from 'clsx'
import map from 'lodash/map'
import React, { createRef, FC, useContext, useState } from 'react'

import { Button } from '@Components/Button'
import { Link } from '@Components/Link'
import { BlockContext } from '@Globals/CMS/Context'
import { pageTypeToDestinationPageType } from '@Globals/Page/Mappers'
import { useTranslation } from '@Globals/Translations'

import styles from './linkTags.module.scss'

export interface LinkTag {
  id: string
  link: string
  name: string
  newTab?: boolean
  type?: string
}

export interface LinkTagsProps {
  tags: LinkTag[]
  text?: string
}

export const LinkTags: FC<LinkTagsProps> = ({ tags, text }) => {
  const { t } = useTranslation()
  const { blockID: sourceID } = useContext(BlockContext)
  const [showMore, setShowMoreMore] = useState(false)
  const ref = createRef<HTMLDivElement>()

  const handleOnClick = () => {
    setShowMoreMore(true)
  }
  return (
    <div className={styles.linkTagsWrapper}>
      <div className={styles.tagsWrapper} ref={ref}>
        {text && <span className={styles.linkTagsText}>{`${text}:`}</span>}
        {map(tags, (tag, index) => {
          if (!tag.type || tag.type === '') { return null }
          return (
            <Link
              key={tag.name}
              analytics={{
                dest_page_type: pageTypeToDestinationPageType(tag.type),
                dest_page_type_id: tag.id,
                source_id: sourceID || '',
              }}
              className={styles.linkTag}
              href={tag.link}
              style={{ display: index < 4 || showMore ? 'flex' : 'none' }}
              target={tag.newTab ? '_blank' : ''}
            >
              {tag.name}
            </Link>
          )
        })}
        {!showMore && tags.length > 4 && (
          <Button className={clsx(styles.seeMoreButton, showMore && styles.hide)} onClick={handleOnClick} variant="outlined">
            {(t('common:SEE_MORE', 'See more').toUpperCase())}
          </Button>
        )}
      </div>
    </div>
  )
}

